exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a[_v-d059cb70]{cursor:pointer}a:hover i[_v-d059cb70],a[_v-d059cb70]:hover{color:gray!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-d059cb70&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Navigation.vue
// module id = 460
// module chunks = 0